__turbopack_context__.v({
  "CatalogDiscount__TopPanel": "styles-module-scss-module__eaXeQW__CatalogDiscount__TopPanel",
  "CatalogDiscount__TopPanelImage": "styles-module-scss-module__eaXeQW__CatalogDiscount__TopPanelImage",
  "CatalogDiscount__TopPanelItem": "styles-module-scss-module__eaXeQW__CatalogDiscount__TopPanelItem",
  "CatalogDiscount__TopPanelList": "styles-module-scss-module__eaXeQW__CatalogDiscount__TopPanelList",
  "CatalogDiscount__TopPanelTitle": "styles-module-scss-module__eaXeQW__CatalogDiscount__TopPanelTitle",
  "GuaranteeLink": "styles-module-scss-module__eaXeQW__GuaranteeLink",
  "ProductGuaranteeTooltip": "styles-module-scss-module__eaXeQW__ProductGuaranteeTooltip",
  "listReset": "styles-module-scss-module__eaXeQW__listReset",
});
